// extracted by mini-css-extract-plugin
module.exports = {"tradingNetworkWrapper":"styles_tradingNetworkWrapper__19QSu","item":"styles_item__2yq1G","image":"styles_image__2PrdF","text":"styles_text__TMibP"};